import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesFaqsMain } from './modules/ui/Main';

const FaqsPage = (
  <SuspensePage>
    <PagesFaqsMain />
  </SuspensePage>
);

export default FaqsPage;
